module.exports = __webpack_public_path__ + "media/images/plus-sign-840e24a1a88485a756edb46c7c71d6d1.svg";